import { makeStyles, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { formatDetails, formatStreet } from "../../../utils/Address";
import IAddressProps from "./IAddressProps";

const useStyles = makeStyles({
    address: {
        whiteSpace: "pre-wrap"
    }
});

const Address = (props: IAddressProps) => {
    const { isLoading, address } = props;

    const { t } = useTranslation("general");
    const styles = useStyles();

    if (isLoading) {
        return (
            <Text block className={styles.address}>
                {t("loading")}
            </Text>
        );
    }

    if (!!address) {
        const street = formatStreet(address),
            details = formatDetails(address);

        return (
            <Text block className={styles.address}>
                {
                    address.title && address.title.trim() !== "" &&
                    <Text block>
                        {address.title.toUpperCase()}
                    </Text>
                }
                {street}
                <br />
                {details}
            </Text>
        );
    }

    return null;
};

export default Address;